import ApolloClientKnowledgeBaseService from '../../../ApolloClientKBService';
import { setKbDepList, setKbCategoryList, setKbArticleList, setKbCatNameList } from '../../../Redux/kb/kbSlice';
import { GET_DEPARTMENT_NAME_LIST } from '../../Customers/query/DepartmentListName';
import { GET_ARTICLES_DATA_LIST } from '../../Customers/query/GetArticlesList';
import { GET_CATEGORIES_DATA_LIST } from '../../Customers/query/GetCategoryList';
import { GET_CATEGORIES_NAME_LIST } from '../../Customers/query/GetCatList';

export const fetchKbDepartments = async ({ params, dispatch }) => {
  try {
    // Fetch kb departments using GraphQL
    const { data } = await ApolloClientKnowledgeBaseService.mutate({
      mutation: GET_DEPARTMENT_NAME_LIST,
      variables: { input: {} },
      fetchPolicy: 'network-only',
    });
    // Optionally dispatch the result if needed
    if (dispatch && data) {
      dispatch(
        setKbDepList(data?.getDepartmentsList?.departmentsData || [])
      );
    }
    return data;
  } catch (error) {
    dispatch(setKbDepList([]));
  }
};

export const fetchKbCategories = async ({ params, dispatch }) => {
  try {
    // Fetch kb departments using GraphQL
    const { data } = await ApolloClientKnowledgeBaseService.mutate({
      mutation: GET_CATEGORIES_DATA_LIST,
      variables: { input: params },
      fetchPolicy: 'network-only',
    });
    // Optionally dispatch the result if needed
    if (dispatch && data) {
      dispatch(
        setKbCategoryList(data?.getAllCategoriesList?.categoriesData || [])
      );
    }
    return data;
  } catch (error) {
    dispatch(setKbCategoryList([]));
  }
};

export const fetchKbArticles = async ({ params, dispatch }) => {
  try {
    // Fetch kb departments using GraphQL
    const { data } = await ApolloClientKnowledgeBaseService.mutate({
      mutation: GET_ARTICLES_DATA_LIST,
      variables: { input: params },
      fetchPolicy: 'network-only',
    });
    // Optionally dispatch the result if needed
    if (dispatch && data) {
      dispatch(
        setKbArticleList(data?.getAllArticlesList?.articlesData || [])
      );
    }
    return data;
  } catch (error) {
    dispatch(setKbArticleList([]));
  }
};

export const fetchKbCatNameList = async ({ params, dispatch }) => {
  try {
    // Fetch kb departments using GraphQL
    const { data } = await ApolloClientKnowledgeBaseService.mutate({
      mutation: GET_CATEGORIES_NAME_LIST,
      variables: { input: {} },
      fetchPolicy: 'network-only',
    });
    // Optionally dispatch the result if needed
    if (dispatch && data) {
      dispatch(
        setKbCatNameList(data?.getCategoriesNameList?.categoryNameData || [])
      );
    }
    return data;
  } catch (error) {
    dispatch(setKbCatNameList([]));
  }
};